import { Box, Card, CardContent, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

type KycInfo = {
  primaryIdentifier?: string;
  secondaryIdentifier?: string;
  dateOfBirth?: string;
  status?: string;
  documentNumber?: string;
  documentCode?: string;
  dateOfExpiry?: string;
  nationality?: string;
  issuingState?: string;
  passphotoBase64?: string;
};

type KycField = {
  key: keyof KycInfo;
  label: string;
};

const FIELDS: KycField[] = [
  { key: "status", label: "KYC Status" },
  { key: "primaryIdentifier", label: "Primary Identifier" },
  { key: "secondaryIdentifier", label: "Secondary Identifier" },
  { key: "documentCode", label: "Document Code" },
  { key: "documentNumber", label: "Document Number" },
  { key: "issuingState", label: "Issuing State" },
  { key: "nationality", label: "Nationality" },
  { key: "dateOfBirth", label: "Date of Birth" },
  { key: "dateOfExpiry", label: "Date of Expiry" },
];

export function KycData(props: { kycData: any }) {
  const kycData = props.kycData;
  const passPhoto = kycData.passphotoBase64 as string;
  const visibleFields = FIELDS.filter(
    (f) => typeof (kycData[f.key] === "string")
  );
  if (!passPhoto && visibleFields.length === 0) {
    return null;
  }
  return (
    <Card variant="outlined">
      <CardContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            maxWidth: 600,
            gap: 2,
          }}
        >
          {passPhoto && (
            <Box
              component="img"
              src={passPhoto}
              alt="KYC Passphoto"
              sx={{
                border: (theme) => `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                width: "120px",
                height: "160px",
                objectFit: "contain",
                flexShrink: 0,
              }}
            />
          )}
          <Grid container spacing={2}>
            {visibleFields.map(({ key, label }) => (
              <Grid key={key} xs={4}>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Typography variant="body1">
                  {String(kycData[key]) || "-"}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
}
